export default "__VITE_ASSET__cb54443b__"